export const EFavorite = {
  no: 0,
  yes: 1,
} as const;

export type EFavoriteType = (typeof EFavorite)[keyof typeof EFavorite];
